import { render } from "./Index_contact.vue?vue&type=template&id=4cd136c0&scoped=true"
import script from "./Index_contact.vue?vue&type=script&lang=js"
export * from "./Index_contact.vue?vue&type=script&lang=js"

import "./Index_contact.vue?vue&type=style&index=0&id=4cd136c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4cd136c0"

export default script